export const baseUrl = "https://manual-api.lambdatest.com/lrms/api/v1"
export const ltUserKey = "lt_reseller_user"
export const StripeKey = "pk_live_A9MKGoWzTIdkKr8AsINtV3zz"